import '@babel/polyfill';

import "./exhibition.css";
import "../commoncss/loading.css";
import {getDevice} from "../commonjs/device.js";
import {google} from "../commonjs/google.js";
import {load_off} from "../commonjs/load.js";
import smoothscroll from 'smoothscroll-polyfill';


window.onload = function(){
            smoothscroll.polyfill();
            load_off();
            google();
            const device = getDevice();
            
            const backside01 = document.getElementById(`backside01`);
            const backside02 = document.getElementById(`backside02`);
            const backside03 = document.getElementById(`backside03`);
            const year_ul = document.getElementById(`year`);
            const year_list = year_ul.getElementsByTagName(`li`);
            const photos = document.getElementById(`photos`);
            const slide_list = Array.from(photos.getElementsByTagName(`li`));
            const picture_odd = document.getElementsByClassName(`picture_odd`);
            const picture_even = document.getElementsByClassName(`picture_even`);
            const over_layer = document.getElementById(`over_layer`);
            const arrow_left = document.getElementById(`arrow_left`);
            const arrow_right = document.getElementById(`arrow_right`);
            
            /*================mobile=============================*/
            const mobile_bar = document.getElementById(`mobile_bar`);
            const mobile_menu = document.getElementById(`mobile_menu`);
            const mobile_header = document.getElementById(`mobile_header`);
            const mobile_year = document.getElementById(`mobile_year`);
            const mobile_list = mobile_year.getElementsByTagName(`li`);
            const to_years = document.getElementsByClassName(`to_years`);
            const close = document.getElementById(`close`);      
    
            function move_elm(elm,point,speed,unit){
                if(speed === undefined){
                    speed = 1000;
                }
                const present = document.defaultView.getComputedStyle(elm,null).left;
                if(unit === undefined){unit = `px`;}
                return elm.animate({left:[present,point+unit]},{
                    direction: `alternate`,
                    duration: speed,
                    fill:`forwards`,
                });
            }
            
            function fade_out(elm,speed){
                if(speed ===undefined){
                    speed = 1000;
                }
                const present = document.defaultView.getComputedStyle(elm,null).opacity;
                
                return elm.animate({opacity:[present,0]},{
                    direction: `alternate`,
                    duration: speed,
                    fill:`forwards`,
                });
            }
    
            function fade_in(elm,speed){
                if(speed ===undefined){
                    speed = 1000;
                }
                const present = document.defaultView.getComputedStyle(elm,null).opacity;
                
                return elm.animate({opacity:[present,1]},{
                    direction: `alternate`,
                    duration: speed,
                    fill:`forwards`,
                });
            }
    
            function show_display(elm,state){
                elm.forEach(v=>{
                    v.style.display = state;
                })
            }
           
            
            const backimg = function (elm,amount){
                this.elm = elm;
                this.amount = amount;
                this.upamount = (function(){
                    return amount -1300;
                })();
                window.addEventListener(`scroll`,this,false);
            }
            
            backimg.prototype.handleEvent = function (){
               console.log(this.elm);
                let y = window.pageYOffset;
                if(this.amount<y){
                        fade_out(this.elm,1000);
                    }
                if(this.upamount>y){
                        fade_in(this.elm,1000);
                }
            }
            
            const bimg01 = new backimg(backside01,3000);
            const bimg02 = new backimg(backside02,5000);
            const bimg03 = new backimg(backside03,7000);
           
            
           const Scoll_nav = function(scroll){
                this.scroll = scroll;
                
            }
            
          
       
            
        function getscreen_position(){
            const w = parseFloat(window.parent.screen.width);
            return -(w*2);
        }
        const before_position = getscreen_position();
        
            
            
        /*=============scrollevent====================*/    
            
        const Years = function(position,tagnum){
            this.position = position;
            this.elm = tagnum;
            tagnum.addEventListener(`click`,this,false);
            tagnum.addEventListener(`mouseover`,(e)=>{
                this.elm.style.backgroundColor = `#7b7463`;
            },false);
            tagnum.addEventListener(`mouseout`,(e)=>{
                this.elm.style.backgroundColor = `black`;
            },false);
        }    
        Years.prototype.handleEvent = function(){
            this.position.scrollIntoView({
                behavior: `smooth`,
            });
            this.elm.style.backgroundColor = `black`;
        }    
        
        const year2013 = new Years(document.getElementById(`2013`),year_list[0]);
        const year2015 = new Years(document.getElementById(`2015`),year_list[1]);
        const year2016 = new Years(document.getElementById(`2016`),year_list[2]);
        const year2017 = new Years(document.getElementById(`2017`),year_list[3]);
        const year2018 = new Years(document.getElementById(`2018`),year_list[4]);    
        
        /*======================slide====================================*/
            
            const Slides = function(exhibition,elm){
                this.exhibition = exhibition;
                this.elm = elm;
                this.elm.addEventListener(`click`,this,false);
            }
            
        Slides.prototype.handleEvent = function(){
            for(let i=0;i<slide_list.length;i++){
                slide_list[i].firstElementChild.src = this.exhibition+`/img/img0${i+1}.jpg`;  
            }
            photos.style.display = `flex`;
            over_layer.style.display = `block`;
            
            
            const move_photos = () =>{
                return new Promise(resolve=>{
                   photos.style.left = parseFloat(window.innerWidth)/2;//スライド要素表示前に表示位置を戻す
                    setTimeout(()=>{
                        resolve();
                    },100);
                });
            }
            
            const show_exhibition = () =>{
                return new Promise(resolve=>{
                     
                    slide_list.forEach((v,i)=>{
                        let slide_trans = 0.2;
                        if(i==2){
                            slide_trans = 1;
                        }
                        if(device==`device`){
                            slide_trans = 1;
                        }
                       v.animate({opacity:[0,slide_trans]},{
                                direction: `alternate`,
                                duration: 1000,
                                fill:`forwards`,
                       });
                    });
                    const in_slide = fade_in(over_layer,1000);
                    
                    
                    in_slide.addEventListener(`finish`,()=>{
                        if(device===`PC`){
                            show_display([arrow_left,arrow_right],`block`);
                            fade_in(arrow_left);
                            fade_in(arrow_right);
                        }
                        show_display([close],`block`);
                        fade_in(close);
                        
                    });
                    
                    
                    document.getElementById(`close`).addEventListener(`click`,addEvent_close,false);
                    over_layer.addEventListener(`click`,addEvent_close,false);     
                    
                });
            }
            
            move_photos()
            .then(show_exhibition);
            
            /*
            const move_photos = function(callback){//スライド位置を整えた後に表示するのでコールバック関数で処理する
                photos.style.left = parseFloat(window.innerWidth)/2;//スライド要素表示前に表示位置を戻す
                callback();
            }
            
            function show_exhibition(){
                slide_list.forEach((v,i)=>{
                        let slide_trans = 0.2;
                        if(i==2){
                            slide_trans = 1;
                        }
                        if(device==`device`){
                            slide_trans = 1;
                        }
                       v.animate({opacity:[0,slide_trans]},{
                                direction: `alternate`,
                                duration: 1000,
                                fill:`forwards`,
                       });
                    });
                    const in_slide = fade_in(over_layer,1000);
                    
                    
                    in_slide.addEventListener(`finish`,()=>{
                        if(device===`PC`){
                            show_display([arrow_left,arrow_right],`block`);
                            fade_in(arrow_left);
                            fade_in(arrow_right);
                        }
                        show_display([close],`block`);
                        fade_in(close);
                        
                    });
                    
                    
                    document.getElementById(`close`).addEventListener(`click`,addEvent_close,false);
                    over_layer.addEventListener(`click`,addEvent_close,false);  
            }
            */
            function addEvent_close(){
               
                this.removeEventListener(`click`,addEvent_close,false);
                if(device===`PC`){
                    fade_out(arrow_left);
                    const after = fade_out(arrow_right);
                    after.addEventListener(`finish`,()=>{
                        show_display([arrow_left,arrow_right],`none`);
                    });
                }  
                    const out = fade_out(close);
                    out.addEventListener(`finish`,()=>{
                        show_display([close],`none`);
                        photos.style.left = ``;
                    });
                 
                const photo = () =>{//promise allでslide_listを処理（foreachは使用できないのでmap処理）
                    return Promise.all(slide_list.map((v)=>{
                        console.log(`done`);
                        return new Promise((resolve)=>{
                        const present = document.defaultView.getComputedStyle(v,null).opacity;    
                         const f = v.animate({opacity:[present,0]},{
                                direction: `alternate`,
                                duration: 1000,
                                fill:`forwards`, 
                            });
                            f.addEventListener(`finish`,()=>{
                               resolve(); 
                            });
                        });
                    }));
                }
                
                const to_be = () =>{
                    return new Promise((resolve)=>{
                        over_layer.style.display = `none`;
                        photos.style.display = `none`;
                        if(device===`PC`){//アニメーションで動かした要素の位置を修正（PCのみ）
                            move_elm(photos,50,10,`%`);
                        }
                        photos.setAttribute(`left`,parseFloat(window.innerWidth)/2);
                        photos.setAttribute(`point`,0);
                        console.log(`done`);
                        resolve();
                    });
                }
                
                photo()
                .then(to_be);
                fade_out(over_layer);
                
            }
            
            move_photos(show_exhibition);
            
        }
        
        const holography = new Slides(`Hologram`,picture_odd[0]);
        const nabeyoko = new Slides(`yadokari`,picture_even[0]);
        const ikebukuro_2015 = new Slides(`Ikebukuro2015`,picture_odd[1]) 
        const nagative = new Slides(`Negative`,picture_even[1]);
        const ikebukuro_2016 = new Slides(`Ikebukuro2016`,picture_odd[2]);
        const negative_then = new Slides(`Negativethen`,picture_odd[3]);
        const karlsruhe_2018 = new Slides(`Karlsruhe2018`,picture_odd[4]);
        const Diversity = new Slides(`Diversity`,picture_even[2]);
        
        const Move_slides = function (direction,elm){
            this.direction = direction;
            this.elm = elm;
            this.elm.addEventListener(`click`,this,false);
        }
          
        Move_slides.prototype.handleEvent = function(){
            let point = !photos.getAttribute(`point`) ? 0 : parseFloat(photos.getAttribute(`point`));
            const rect = photos.getBoundingClientRect();
            
            
            const position = !photos.getAttribute(`left`) ?  parseFloat(window.innerWidth)/2 : parseFloat(photos.getAttribute(`left`));
            const how_move = parseFloat(document.defaultView.getComputedStyle(photos,null).width)/5;
            if(this.direction===`left`){
                if(point===2){return;}
                move_elm(photos,position+how_move,1000,`px`);
                photos.setAttribute(`left`,position+how_move);
                photos.setAttribute(`point`,point+1);
                slide_in_out(slide_list[parseFloat(photos.getAttribute(`point`))*-1+2],1);
            }else{
                if(point==-2){return;}
                move_elm(photos,position-how_move,1000,`px`);
                photos.setAttribute(`left`,position-how_move);
                photos.setAttribute(`point`,point-1);
                slide_in_out(slide_list[parseFloat(photos.getAttribute(`point`))*-1+2],1);
            }//+と-の方向が逆なので数値を反転させる
            slide_in_out(slide_list[point*-1+2],0.2);
            this.elm.animate({opacity:[1,0.2,1]},{//矢印点滅
                        direction: `alternate`,
                        duration: 500,
                        fill:`forwards`,            
                });
            
            function slide_in_out(elm,melt){
                const present = document.defaultView.getComputedStyle(elm,null).opacity;
                elm.animate({opacity:[present,melt]},{
                        direction: `alternate`,
                        duration: 500,
                        fill:`forwards`,     
                });
            }
            
        }
        
        const left_side = new Move_slides(`left`,arrow_left);
        const right_side = new Move_slides(`right`,arrow_right);    
            
        /*================mobile=======================================*/
        const slide_speed = 800;    
            
         mobile_bar.addEventListener(`click`,(e)=>{
             move_elm(mobile_menu,0,slide_speed),`px`;
             fade_in(close,1000);
            close.addEventListener(`click`,disappear_menu,false); 
         },false);   
            
        mobile_header.addEventListener(`click`,disappear_menu,false);
            
            
        function disappear_menu(e){
            move_elm(mobile_menu,0,slide_speed,`px`);
            fade_out(close,1000);
            close.removeEventListener(`click`,disappear_menu,false);
        }    
            
        const Scroll_from_year = function(scroll,elm){
            this.scroll = scroll;        
            this.elm = elm;
            this.elm.addEventListener(`click`,this,false);
        }   
        
        Scroll_from_year.prototype.handleEvent = function(){
            const position = this.scroll;
            const move_slide = move_elm(mobile_menu,`-100`,1000,`%`);
            
            move_slide.addEventListener(`finish`,()=>{
                position.scrollIntoView({
                    behavior:`smooth`,
                })
            });
        } 
        
        const mobile_2013 = new Scroll_from_year(document.getElementById(`2013`),to_years[0]);
        const mobile_2015 = new Scroll_from_year(document.getElementById(`2015`),to_years[1]);
        const mobile_2016 = new Scroll_from_year(document.getElementById(`2016`),to_years[2]);
        const mobile_2017 = new Scroll_from_year(document.getElementById(`2017`),to_years[3]);
        const mobile_2018 = new Scroll_from_year(document.getElementById(`2018`),to_years[4]);     
        to_years[6].addEventListener(`touchstart`,()=>{
            move_elm(mobile_menu,`-100`,1000,`%`);
        });
            
        /*======================photos move================================*/    
        photos.addEventListener(`touchstart`,(e)=>{
            get_left(photos);
            e.preventDefault();
            photos.setAttribute(`touch_start`,e.touches[0].clientX);
                photos.addEventListener(`touchmove`,touch_moveX,false);        
        },false);    
       
        function touch_moveX(e){
                    const how_long_move = e.touches[0].clientX-parseFloat(photos.getAttribute(`touch_start`));
                    photos.style.left = (parseFloat(photos.getAttribute(`left`))+how_long_move)+`px`;
                        photos.addEventListener(`touchend`,(e)=>{
                            photos.removeEventListener(`touchmove`,touch_moveX,false);
                        },false);
        }
        /*===============================================================*/
        function get_left(elm){
            const rect = elm.getBoundingClientRect();
            //スライドの横幅はウインドウサイズの幅の中心を取得して動かした方がうまくいく。
            const positionX = !elm.style.left ? parseFloat(window.innerWidth)/2 : parseFloat(elm.style.left);
            const positionY = !elm.style.top ? Math.abs(rect.top/4) : parseFloat(elm.style.top);
            elm.setAttribute(`left`,positionX);//DOMのleftの絶対値から4割った数がleftの数値のよう（transformで位置の調整をしているでの少し計算が面倒になっている）
            elm.setAttribute(`top`,positionY);
        }    
            
            
            
        mobile_menu.addEventListener(`touchstart`,(e)=>{
            get_left(mobile_menu);
            mobile_menu.setAttribute(`touch_start`,e.touches[0].clientY);
            mobile_menu.addEventListener(`touchmove`,touch_moveY,false);
        },false);    
            
        function touch_moveY(e){
            e.preventDefault();//イベントの伝番をタッチムーブ時にやめる（スタート時にやらない　クリックイベントまで無反応になるため）
            const move_y = e.touches[0].clientY-parseFloat(mobile_menu.getAttribute(`touch_start`));
             
            mobile_menu.style.top = (parseFloat(mobile_menu.getAttribute(`top`))+move_y)+`px`;
                mobile_menu.addEventListener(`touchend`,(e)=>{
                   mobile_menu.removeEventListener(`touchmove`,touch_moveY,false); 
                   
                });
        }    
            
        function stop_event(e){
            e.preventDefault();
        }    
            
          }// end of window load
        